export function reduceOrNull<T>(array: T[], compareFunc: (aVal: T, bVal: T) => T): T | null {
    return array.reduce<T | null>((prev, cur) => (prev ? compareFunc(prev, cur) : cur), null);
}
